import HNSColors from "../../../ui library/HNSColors";
import { PAYMENTS_MODAL_STYLES } from "../../payments/styles/styles";

export const SETTLEMENT_STYLES = {
  sectionCard: {
    backgroundColor: HNSColors.neutrals[900],
  },
  sectionIcon: {
    width: "30px",
    height: "30px",
  },
  sectionIconColor: HNSColors.primary[500],
  sectionHeaderIcon: {
    width: "30px",
    height: "30px",
    flexShrink: 0,
  },
  sectionTitle: {
    color: HNSColors.neutrals[100],
  },
  statusIcon: {
    width: "24px",
    height: "24px",
  },
  infoIcon: {
    width: "16px",
    height: "16px",
  },
  fieldLabel: {
    color: HNSColors.neutrals[600],
    fontSize: "14px",
    fontWeight: 500,
    marginBottom: "6px",
  },
  fieldLabelInline: {
    color: HNSColors.neutrals[600],
    fontSize: "14px",
    fontWeight: 500,
    marginBottom: 0,
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      padding: 0,
      borderRadius: "8px",
      transition: "border-color 0.3s",
      "& fieldset": { borderColor: HNSColors.neutrals[400] },
      "&.Mui-focused fieldset": { border: `1.5px solid ${HNSColors.secondary[500]}` },
      "& .MuiInputBase-input": { padding: "8px" },
      "& .MuiInputAdornment-root": { color: HNSColors.neutrals[600] },
      "& .MuiInputAdornment-positionStart": {
        paddingLeft: "10px",
        paddingRight: "4px",
      },
      "& .MuiInputAdornment-positionEnd": {
        paddingRight: "10px",
      },
    },
  },
  datePickerTextField: {
    "& .MuiOutlinedInput-root": {
      padding: 0,
      borderRadius: "8px",
      transition: "border-color 0.3s",
      "& fieldset": { borderColor: HNSColors.neutrals[400] },
      "&.Mui-focused fieldset": { border: `1.5px solid ${HNSColors.secondary[500]}` },
      "& .MuiInputBase-input": { padding: "8px" },
      "& .MuiSelect-icon": { color: HNSColors.primary[500] },
    },
  },
  actionButtonContainer: {
    textTransform: "none",
    borderRadius: "500px",
    paddingY: "6px",
    boxShadow: "none",
  },
  modalTitle: {
    color: HNSColors.primary[500],
    fontFamily: "Roboto, sans-serif",
    fontWeight: 600,
  },
  modalMetaText: {
    color: HNSColors.neutrals[400],
    fontSize: 14,
  },
  exportModalHeader: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    paddingRight: 4,
  },
  exportModalCloseButton: {
    color: HNSColors.neutrals[400],
    alignSelf: "flex-start",
  },
  exportPrimaryButton: {
    fontSize: "1rem",
    minWidth: 132,
    paddingX: 3.5,
    paddingY: 1.2,
  },
  addButton: {
    borderRadius: "500px",
    color: HNSColors.neutrals[900],
    backgroundColor: HNSColors.secondary[500],
    "&:hover": {
      background: HNSColors.secondary[600],
      color: HNSColors.neutrals[900],
    },
  },
  dropdownArrowIcon: {
    fontSize: 24,
    color: HNSColors.primary[500],
    marginRight: "8px",
  },
  listbox: {
    maxHeight: 200,
    overflow: "auto",
    "&::-webkit-scrollbar": { width: "6px" },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: HNSColors.primary[500],
      borderRadius: "3px",
    },
  },
  menuPaper: {
    boxShadow: "none",
    borderRadius: 2,
    border: `1px solid ${HNSColors.secondary[500]}`,
    "& .MuiMenuItem-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 3,
      px: 2,
    },
    "& .MuiMenuItem-root:hover": {
      backgroundColor: HNSColors.tertiary[900],
    },
  },
  menuListItemIcon: {
    justifyContent: "flex-end",
    minWidth: "auto",
  },
  menuEditIcon: {
    width: "1.25rem",
  },
  moreIcon: {
    color: HNSColors.primary[500],
    fontSize: 24,
  },
  loadingOverlay: {
    backgroundColor: HNSColors.neutrals[900],
  },
  scrollbarSx: {
    boxShadow: "none",
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: HNSColors.primary[500],
    },
  },
  emptyStateText: {
    color: HNSColors.neutrals[400],
  },
  emptyStateCard: {
    backgroundColor: HNSColors.tertiary[900],
    color: HNSColors.primary[500],
  },
  detailLabelText: {
    color: HNSColors.neutrals[500],
  },
  detailValueText: {
    color: HNSColors.neutrals[300],
  },
  infoFieldLabel: {
    color: HNSColors.neutrals[400],
  },
  subtleBorder: {
    borderColor: HNSColors.neutrals[800],
  },
  summaryCardTitle: {
    color: HNSColors.neutrals[400],
  },
  subtitle: {
    color: HNSColors.neutrals[100],
  },
  tableRowUnsetBorder: {
    "& > *": { borderBottom: "unset" },
  },
  textFieldEditIcon: {
    color: HNSColors.primary[500],
    fontSize: 18,
  },
  datePickerButton: {
    marginRight: "8px",
    color: HNSColors.primary[500],
  },
  warningIcon: {
    color: HNSColors.primary[500],
    fontSize: 24,
  },
  editableIconButton: {
    color: HNSColors.primary[500],
    p: "5px",
  },
  editableIcon: {
    fontSize: 18,
  },
  editableSuccessIcon: {
    color: HNSColors.success[400],
    fontSize: 18,
  },
  editableFailureIcon: {
    color: HNSColors.failure[400],
    fontSize: 18,
  },
  deleteText: {
    color: HNSColors.failure[500],
  },
  deleteIcon: {
    color: HNSColors.failure[500],
  },
  singleSelectHeaderRow: {
    backgroundColor: HNSColors.tertiary[900],
  },
};

export const getSettlementActionButtonSx = ({ disabled, isOutlined }) => ({
  ...SETTLEMENT_STYLES.actionButtonContainer,
  border: isOutlined ? "1px solid" : "none",
  backgroundColor: isOutlined
    ? HNSColors.neutrals[900]
    : disabled
      ? HNSColors.neutrals[800]
      : HNSColors.secondary[500],
  color: isOutlined
    ? HNSColors.secondary[500]
    : disabled
      ? HNSColors.neutrals[500]
      : HNSColors.neutrals[900],
  borderColor: isOutlined ? HNSColors.secondary[500] : "transparent",
  "&:hover": {
    boxShadow: "none",
    backgroundColor: isOutlined ? HNSColors.secondary[900] : HNSColors.secondary[600],
    color: isOutlined ? HNSColors.secondary[500] : HNSColors.neutrals[900],
    borderColor: isOutlined ? HNSColors.neutrals[900] : "transparent",
  },
});

export const getSettlementTextFieldSx = ({ isInteractive }) => ({
  ...SETTLEMENT_STYLES.textField,
  "& .MuiOutlinedInput-root": {
    ...SETTLEMENT_STYLES.textField["& .MuiOutlinedInput-root"],
    ...(isInteractive ? { cursor: "pointer" } : {}),
  },
  ...(isInteractive
    ? {
        "& .MuiInputBase-input": { cursor: "pointer" },
        "& .MuiInputAdornment-root": { cursor: "pointer" },
      }
    : {}),
});

export const getSettlementModalTextFieldSx = () => ({
  ...PAYMENTS_MODAL_STYLES.textField,
  "& .MuiInputAdornment-positionStart": {
    marginLeft: "12px",
    marginRight: "4px",
  },
});

export const getSettlementMedicalAmountFieldSx = () => ({
  ...PAYMENTS_MODAL_STYLES.textField,
  "& .MuiOutlinedInput-root": {
    ...PAYMENTS_MODAL_STYLES.textField["& .MuiOutlinedInput-root"],
    "& .MuiInputAdornment-positionStart": {
      paddingLeft: "10px",
      paddingRight: "4px",
    },
    "& .MuiInputAdornment-positionEnd": {
      paddingRight: "10px",
    },
  },
});
